<template>
	<div id="cds">
		<div class="page-title">
			<el-button type="primary" round>CONTRATS DE SERVICES</el-button>
		</div>
		<div class="page-contrat">
			<div class="col-md-4">
				<el-form :inline="true" size="mini" :model="formSearchTiers" id="formSearchTiers" class="demo-form-inline" label-position="top" >
					<el-form-item class="no-padding col-md-9">
						<el-select class="inline-input" v-model="formSearchTiers.idTiers" filterable remote reserve-keyword placeholder="Rechercher un tiers ..." :remote-method="remoteMethod" :loading="loading" @select="handleSelect">
							<el-option v-for="item in tiers" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="no-padding col-md-1">
					</el-form-item>
					<el-form-item class="no-padding col-md-2">
						<el-button type="warning" @click="loadTiers">Charger</el-button>
					</el-form-item>
				</el-form>
				
				<el-tabs type="card" @tab-click="handleClick">
					<el-tab-pane label="SIEGE">
						<el-form ref="formContrat" size="mini" :model="formContrat" label-position="top">
							<el-form-item prop="facturation">
								<el-checkbox-group v-model="formContrat.facturationSiege">
									<el-checkbox @change="changeFacturationSiege" label="Facturation siège" name="facturation"></el-checkbox>
								</el-checkbox-group>
							</el-form-item>

							<el-form-item label="Dénomination :">
								<el-input v-model="formContrat.siege.denomination"></el-input>
							</el-form-item>

							<el-form-item label="Forme Juridique :">
								<el-input v-model="formContrat.siege.formeJuridique"></el-input>
							</el-form-item>

							<el-form-item label="Siret :">
								<el-input v-model="formContrat.siege.siret"></el-input>
							</el-form-item>

							<el-form-item label="Adresse :">
								<el-input v-model="formContrat.siege.adresse"></el-input>
							</el-form-item>

							<div class="flexbox">
								<el-form-item class="no-padding col-md-2" label="CP :">
									<el-input v-model="formContrat.siege.cp"></el-input>
								</el-form-item>
								<el-form-item class="no-padding col-md-1">
								</el-form-item>
								<el-form-item class="no-padding col-md-9" label="Ville :">
									<el-input v-model="formContrat.siege.ville"></el-input>
								</el-form-item>
							</div>
							
							<el-form-item label="Représentant légal :">
								<el-input v-model="formContrat.siege.contact"></el-input>
							</el-form-item>

							<el-form-item label="Fonction :">
								<el-input v-model="formContrat.siege.fonction"></el-input>
							</el-form-item>

							<el-form-item label="Courriel :">
								<el-input v-model="formContrat.siege.courriel"></el-input>
							</el-form-item>

							<el-form-item label="Téléphone :">
								<el-input v-model="formContrat.siege.telephone"></el-input>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<el-tab-pane label="SITE D'INSTALLATION">
						<el-form ref="formContrat" size="mini" :model="formContrat" label-position="top">
							<div class="flexbox">
								<el-form-item class="col-md-6" prop="facturation">
									<el-checkbox-group v-model="formContrat.facturationSite">
										<el-checkbox @change="changeFacturationSite" label="Facturation site d'installation" name="facturation"></el-checkbox>
									</el-checkbox-group>
								</el-form-item>
								<el-form-item class="col-md-6">
									<el-button type="success" @click="cloneSiege">- RECOPIE SIEGE -</el-button>
								</el-form-item>
							</div>
								
							<el-form-item label="Dénomination :">
								<el-input v-model="formContrat.siteInstallation.denomination"></el-input>
							</el-form-item>

							<el-form-item label="Forme Juridique :">
								<el-input v-model="formContrat.siteInstallation.formeJuridique"></el-input>
							</el-form-item>

							<el-form-item label="Siret :">
								<el-input v-model="formContrat.siteInstallation.siret"></el-input>
							</el-form-item>

							<el-form-item label="Adresse :">
								<el-input v-model="formContrat.siteInstallation.adresse"></el-input>
							</el-form-item>

							<div class="flexbox">
								<el-form-item class="no-padding col-md-2" label="CP :">
									<el-input v-model="formContrat.siteInstallation.cp"></el-input>
								</el-form-item>
								<el-form-item class="no-padding col-md-1">
								</el-form-item>
								<el-form-item class="no-padding col-md-9" label="Ville :">
									<el-input v-model="formContrat.siteInstallation.ville"></el-input>
								</el-form-item>
							</div>
							
							<el-form-item label="Contact technique :">
								<el-input v-model="formContrat.siteInstallation.contact"></el-input>
							</el-form-item>

							<el-form-item label="Fonction :">
								<el-input v-model="formContrat.siteInstallation.fonction"></el-input>
							</el-form-item>

							<el-form-item label="Courriel :">
								<el-input v-model="formContrat.siteInstallation.courriel"></el-input>
							</el-form-item>

							<el-form-item label="Téléphone :">
								<el-input v-model="formContrat.siteInstallation.telephone"></el-input>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</div>

			<div class="col-md-8">
				<el-form :inline="true" size="mini" :model="formSearchContrat" id="formSearchContrat" class="demo-form-inline" label-position="top" >
					<el-form-item class="no-padding col-md-8">
					</el-form-item>
					<el-form-item class="col-md-2">
						<el-button type="success" @click="loadCds">- RECUPERATION -</el-button>
					</el-form-item>
					<el-form-item class="col-md-2">
						<el-button type="danger" @click="resetCds">RESET</el-button>
					</el-form-item>
					<el-form-item class="col-md-12">
						<el-select v-model="value" filterable placeholder="Select">
							<el-option v-for="item in optionsCds" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>

				<el-form ref="formContrat" size="mini" :model="formContrat" label-position="top">
					<div class="flexbox">
						<el-form-item class="no-padding col-md-3" label="Durée d'engagement :">
							<el-select v-model="value">
								<el-option v-for="item in optionsEngagement" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item class="no-padding col-md-1">
						</el-form-item>

						<el-form-item class="no-padding col-md-5" label="Nom du contrat :">
							<el-input v-model="formContrat.detailsContrat.nomContrat"></el-input>
						</el-form-item>

						<el-form-item class="no-padding col-md-1">
						</el-form-item>

						<el-form-item class="no-padding col-md-4" label="Commercial :">
							<el-select v-model="value" filterable>
								<el-option v-for="item in optionsCommercial" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</div>

					<el-table :data="formContrat.detailsContrat.services" style="width: 100%">
						<el-table-column label="Services vendus" width="180">
							<template slot-scope="scope">
								<i class="el-icon-time"></i>
								<span style="margin-left: 10px">{{ scope.row.date }}</span>
							</template>
						</el-table-column>
						<el-table-column label="QTE" width="180">
							<template slot-scope="scope">
								<el-form-item>
									<el-input v-model="scope.qte"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="PU en € HT/mois" width="180">
							<template slot-scope="scope">
								<el-form-item>
									<el-input v-model="scope.pu"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="TOTAL en € HT" width="180">
							<template slot-scope="scope">
								<el-form-item>
									<el-input v-model="scope.total"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="FAS en € HT" width="180">
							<template slot-scope="scope">
								<el-form-item>
									<el-input v-model="scope.fas"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column label="Commentaires" width="180">
							<template slot-scope="scope">
								<el-form-item>
									<el-input v-model="scope.commentaire"></el-input>
								</el-form-item>
							</template>
						</el-table-column>
						<el-table-column>
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">Supprimer</el-button>
							</template>
						</el-table-column>
					</el-table>

					<el-form-item label="Observations :">
						<el-input style='resize:none;' type="textarea" v-model="formContrat.detailsContrat.observations">
						</el-input>
					</el-form-item>
					
					<el-form-item label="Objets - Matériels">
						<el-input style='resize:none;' type="textarea" v-model="formContrat.detailsContrat.objetsMateriels">
						</el-input>
					</el-form-item>

					<el-form-item>
						<el-button id='btnCreateContract' type="warning" @click="createContrat">Créer</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import scriptCds from '../../../script/script_cds'
export default {
	data () {
		return {
			formSearchTiers:{
				idTiers: ""
			},
			formContrat:{
				siege:{
					denomination:'',
					formeJuridique:'',
					siret:'',
					adresse:'',
					cp:'',
					ville:'',
					contact:'',
					fonction:'',
					courriel:'',
					telephone:''
				},
				facturationSiege:true,
				facturationSite:false,
				siteInstallation:{
					denomination:'',
					formeJuridique:'',
					siret:'',
					adresse:'',
					cp:'',
					ville:'',
					contact:'',
					fonction:'',
					courriel:'',
					telephone:''
				},
				detailsContrat:{
					dureeEngagement:'36',
					nomContrat:'',
					commercial:'',
					services:[],
					observations:'',
					objetsMateriels:'',
				}
			},
			optionsCds:[],
			optionsEngagement:[
				{
					value:'12',
					label:'12 mois'
				},
				{
					value:'24',
					label:'24 mois'
				},
				{
					value:'36',
					label:'36 mois'
				},
				{
					value:'48',
					label:'48 mois'
				},
				{
					value:'60',
					label:'60 mois'
				}
			],
			optionsCommercial:[],
			optionsServices:[],
			tiers:[],
			loading: false
		}
	},
	methods:{
		searchTiers: scriptCds.searchTiers,
		getContacts: scriptCds.getContacts,
		cloneSiege(){
			this.formContrat.siteInstallation = this.formContrat.siege
		},
		changeFacturationSiege(){
			this.formContrat.facturationSite = !this.formContrat.facturationSiege
		},
		changeFacturationSite(){
			this.formContrat.facturationSiege = !this.formContrat.facturationSite
		},
		createContrat(){
			console.log(this.formContrat)
		},
		remoteMethod(queryString) {
			if (queryString !== '') {
				this.loading = true;
				setTimeout(() => {
					this.searchTiers(queryString)
					this.loading = false;
				}, 200);
			} else {
				this.tiers = [];
			}
		},
		loadCds(){

		},
		loadTiers(){
			let tier = this.tiers.filter(tier => tier.value == this.formSearchTiers.idTiers)
			let infoTier = tier[0].tiers
			this.getContacts(this.formSearchTiers.idTiers)
			this.formContrat.siege.denomination = infoTier.name
			this.formContrat.siege.formeJuridique = infoTier.forme_juridique
			this.formContrat.siege.siret = infoTier.idprof2
			this.formContrat.siege.adresse = infoTier.address
			this.formContrat.siege.cp = infoTier.zip
			this.formContrat.siege.ville = infoTier.town
		}
	}
}
</script>

<style>
.flexbox{
	display: flex;
}

.no-padding{
	padding: 0;
}

#cds{
}

.page-contrat{
	display: flex;
}

.page-title{
	text-align: center;
	padding: 2em;
}

#formSearchTiers{
	padding: 1em;
}

#formSearchTiers .el-select{
	width: 100%;
}

#formSearchContrat .el-select{
	width: 100%;
	padding: 2em 0;
}

#formSearchContrat .el-button--mini, .el-button--mini.is-round{
	width: 100%;
}

#cds .el-form--label-top .el-form-item__label{
	padding: 0;
	margin: 0;
}

#cds .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
	margin: 0;
}

#btnCreateContract{
	margin: 2em;
}
</style>